import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { ArrowRight } from 'lucide-react'
import { categoriesService } from '@/services/categoriesService'
import { ProductFormDialog } from './ProductsPage'
import { ROUTES } from '@/constants/routes'

export default function ProductNewPage() {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const lang = i18n.language

  const { data: catTree } = useQuery({
    queryKey: ['categories-tree'],
    queryFn: categoriesService.getTree,
  })
  const flatCats = []
  const flatten = (arr, depth = 0) => {
    arr?.forEach((c) => {
      flatCats.push({ id: c.id, name: (depth > 0 ? '— ' : '') + (c.name?.[lang] || c.name?.ar || c.name?.en || '') })
      if (c.children?.length) flatten(c.children, depth + 1)
    })
  }
  flatten(catTree)

  return (
    <div className="space-y-6">
      {/* ── Header ────────────────────────────────────────────────────────── */}
      <div className="flex items-center gap-4">
        <button onClick={() => navigate(ROUTES.PRODUCTS)} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
          <ArrowRight size={24} className="text-navy" />
        </button>
        <h1 className="font-black text-navy text-2xl" style={{ fontFamily: 'Cairo, sans-serif' }}>
          {t('products.addTitle')}
        </h1>
      </div>

      <ProductFormDialog
        mode="create"
        initialData={null}
        flatCats={flatCats}
        onClose={() => navigate(ROUTES.PRODUCTS)}
        onSuccess={() => navigate(ROUTES.PRODUCTS)}
        t={t}
        lang={lang}
        inline
      />
    </div>
  )
}
